import 'katex/dist/katex.min.css';

import type { WrapPageElementBrowserArgs } from 'gatsby';
import React from 'react';

import Root from './src/Root';

// 클라이언트 사이드에서 댓글 컴포넌트가 로드되도록 설정
export const onClientEntry = () => {
  // 클라이언트 사이드에서 초기화 코드 실행
  console.log('클라이언트 사이드 실행 시작');
};

export const wrapPageElement = ({ element }: WrapPageElementBrowserArgs) => {
  return <Root>{element}</Root>;
};
